import { offsetLimitPagination } from '@apollo/client/utilities';
import type { FieldPolicy, Reference } from '@apollo/client';

const practiceItems: FieldPolicy<Reference[]> = {
    ...offsetLimitPagination(['type', 'status', 'moduleId']),
};

export default practiceItems;
